import { FormGroup } from '@angular/forms';

export class FormGroupUtil {

    public static disableOrEnableSpecificControl(formGroup: FormGroup, control: string, disabled: boolean) {
        if (disabled) {
            formGroup.controls[control].disable();
            formGroup.controls[control].setValue('');
        } else {
            formGroup.controls[control].enable();
        }
    }

}
